var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16667L10 11.6667L16.6667 5",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16667L10 11.6667L16.6667 5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16667L10 11.6667L16.6667 5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16667L10 11.6667L16.6667 5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 9.99972C16.6688 11.4161 16.2174 12.7955 15.3802 13.938C14.5431 15.0805 13.3639 15.9267 12.0135 16.3539C10.6631 16.7811 9.21179 16.7671 7.86987 16.314C6.52796 15.8609 5.36522 14.9922 4.55022 13.8339C3.73523 12.6755 3.31033 11.2877 3.33713 9.87156C3.36393 8.45547 3.84104 7.08471 4.69929 5.95801C5.55754 4.8313 6.75232 4.00722 8.11042 3.60522C9.46852 3.20322 10.9194 3.2442 12.2526 3.72222",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 9.99972C16.6688 11.4161 16.2174 12.7955 15.3802 13.938C14.5431 15.0805 13.3639 15.9267 12.0135 16.3539C10.6631 16.7811 9.21179 16.7671 7.86987 16.314C6.52796 15.8609 5.36522 14.9922 4.55022 13.8339C3.73523 12.6755 3.31033 11.2877 3.33713 9.87156C3.36393 8.45547 3.84104 7.08471 4.69929 5.95801C5.55754 4.8313 6.75232 4.00722 8.11042 3.60522C9.46852 3.20322 10.9194 3.2442 12.2526 3.72222",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 9.99972C16.6688 11.4161 16.2174 12.7955 15.3802 13.938C14.5431 15.0805 13.3639 15.9267 12.0135 16.3539C10.6631 16.7811 9.21179 16.7671 7.86987 16.314C6.52796 15.8609 5.36522 14.9922 4.55022 13.8339C3.73523 12.6755 3.31033 11.2877 3.33713 9.87156C3.36393 8.45547 3.84104 7.08471 4.69929 5.95801C5.55754 4.8313 6.75232 4.00722 8.11042 3.60522C9.46852 3.20322 10.9194 3.2442 12.2526 3.72222",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 9.99972C16.6688 11.4161 16.2174 12.7955 15.3802 13.938C14.5431 15.0805 13.3639 15.9267 12.0135 16.3539C10.6631 16.7811 9.21179 16.7671 7.86987 16.314C6.52796 15.8609 5.36522 14.9922 4.55022 13.8339C3.73523 12.6755 3.31033 11.2877 3.33713 9.87156C3.36393 8.45547 3.84104 7.08471 4.69929 5.95801C5.55754 4.8313 6.75232 4.00722 8.11042 3.60522C9.46852 3.20322 10.9194 3.2442 12.2526 3.72222",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.a4091c1b02ce399efedea074a02eb7b7.svg";
export { ForwardRef as ReactComponent };